










































































import { LineItem } from "@/models/campaign";
import { Vue, Component, Prop } from "vue-property-decorator";
import DefinitionValue from "@/models/definitionValue";
import { DefinitionList } from "@/models/definition";
import Site from "@/models/site";
import AdUnit from "@/models/adUnit";
import SitesAPI from "@/services/sites";
import AdUnitsAPI from "@/services/adUnits";
import DefinitionsAPI from "@/services/definitions";
import TableActions from "@/components/TableActions.vue";
import { LayoutModule } from "@/store/layout";
import LineItemForm from "./LineItemForm.vue";
import { LineItemModule } from "@/store/lineItem";
import BannerForm from "./BannerForm.vue";
import { QueryParams } from "@/models/general";
import { composeDateRange } from "@/helpers/dateHelpers";

@Component({
  components: { TableActions },
})
export default class LineItemTable extends Vue {
  @Prop({ default: null }) campaign_id!: string;
  @Prop({ default: () => [] }) lineItems!: LineItem;
  @Prop({ default: () => [] }) adUnits!: AdUnit[];
  @Prop({ default: () => [] }) definitions!: DefinitionList[];
  @Prop({ default: () => [] }) sites!: Site[];
  @Prop({ default: false }) edit!: boolean;
  @Prop({ default: true }) setBanner!: boolean;
  @Prop({ default: "" }) hightLightLineItem!: string | (string | null)[];
  @Prop({ default: true }) canModify!: boolean;

  headers = [
    {
      text: this.$t("campaigns.model.site"),
      sortable: true,
      value: "siteId",
    },
    {
      text: this.$t("campaigns.model.ad_unit"),
      sortable: true,
      value: "adUnitId",
    },
    {
      text: this.$t("campaigns.model.definitions"),
      sortable: false,
      value: "definitionValueIds",
    },
    {
      text: this.$t("campaigns.line_items.date_range"),
      sortable: false,
      value: "start",
    },
    // {
    //   text: this.$t("campaigns.line_items.discount"),
    //   sortable: false,
    //   value: "discount",
    // },
    {
      text: "",
      sortable: false,
      value: "id",
    },
  ];

  // sites: Site[] = [];
  // adUnits: AdUnit[] = [];

  created(): void {
    this.getData();
  }

  async getData(): Promise<void> {
    LayoutModule.showLoader();
    if (this.campaign_id === null) {
      // this.getSites();
      // this.getAdUnits();
      // this.getDefinitions();
    }
    LayoutModule.hideLoader();
  }

  async getSites(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await SitesAPI.getSites(params);
      this.sites = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getAdUnits(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
        fields: ["id", "ref", "name"],
      };

      const r = await AdUnitsAPI.list(params);
      this.adUnits = r.data;
      console.log("adunits", this.adUnits);
    } catch (e) {
      console.log(e);
    }
  }

  async getDefinitions(): Promise<void> {
    try {
      const r = await DefinitionsAPI.list(1, 1000);
      this.definitions = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  composeAdUnit(id: string, item: LineItem): string {
    const value = this.adUnits.find((adUnit: AdUnit) => {
      return adUnit.id === id;
    });
    return value ? value.name : "";
  }

  composeSite(id: string): string {
    const value = this.sites.find((site: Site) => {
      return site.id === id;
    });

    return value ? value.name : "";
  }

  composeDefinition(id: string): string {
    let value: DefinitionValue | undefined;
    this.definitions.forEach((definition: DefinitionList) => {
      let v = definition.values.find((dv: DefinitionValue) => dv.id === id);
      if (v) {
        value = v;
      }
    });

    return value ? value.name : "";
  }

  composeDate(start: Date, end: Date): string {
    return composeDateRange(start, end);
  }

  editLineItem(item: LineItem): void {
    LineItemModule.setCurrentLineItem(item);

    LayoutModule.setRightDrawerComponent(LineItemForm);
    LayoutModule.setRightDrawerComponentProps({ initialLineItem: item });
    LayoutModule.showRightDrawer();
  }

  editBanner(item: LineItem): void {
    LineItemModule.setCurrentLineItem(item);
    LayoutModule.setRightDrawerComponent(BannerForm);
    LayoutModule.showRightDrawer();
  }

  onSelectItems(items: LineItem[]): void {
    console.log(items);
    return;
  }

  deleteLineItem(item: LineItem): void {
    this.$emit("onDeleteItem", item);
    return;
  }

  hasBanner(item: LineItem): boolean {
    if (item.banner === undefined) return false;
    if (item.banner.targetUrl === null) return false;

    return true;
  }
}
